import { SiteLink } from "shared/components/SiteLink";
import { HOMEPAGE_TYPE } from "clariah/utils/constants";
import { LARGE } from "shared/utils/constants";
import { Logo } from "clariah/components/Logo";
import { ExternalIcon } from "shared/components/Icons";
import { MaxWidth } from "shared/components/MaxWidth";
import cx from "classnames";
import styles from "./Footer.module.css";

export const Footer = ({ footer, withBorder }) => {
  const { menus, footerMenu } = footer || {};

  return (
    <footer className={cx(styles.footer, { [styles.withBorder]: withBorder })}>
      <MaxWidth size={LARGE}>
        <div
          className={cx(styles.menuFooterContainer, {
            [styles.withBorder]: withBorder,
          })}
        >
          <div className={styles.menuFooter}>
            <div className={styles.logoContainer}>
              <SiteLink
                className={styles.logoLink}
                type={HOMEPAGE_TYPE}
                href=""
                title="Homepage"
              >
                <Logo />
              </SiteLink>
            </div>
            {(menus || []).map(({ items, title }) => (
              <div key={title}>
                <h2 className={styles.title}>{title}</h2>
                <ul className={styles.linkList}>
                  {(items || []).map(({ label, item }) => {
                    const isOutOfScope =
                      item?.scope?.ineo && !item?.scope.clariah;

                    return (
                      <li key={label}>
                        <SiteLink
                          href={item?.slug?.current || ""}
                          type={item?._type}
                          isOutOfScope={isOutOfScope}
                        >
                          {label}
                          {isOutOfScope && <ExternalIcon />}
                        </SiteLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </MaxWidth>
      <div className={styles.realFooterContainer}>
        <MaxWidth size={LARGE}>
          <div className={styles.realFooter}>
            <div className={styles.realFooterLinks}>
              {(footerMenu || []).map(({ label, item }) => {
                const isOutOfScope = item?.scope?.ineo && !item?.scope.clariah;
                return (
                  <SiteLink
                    key={label}
                    href={item?.slug?.current || ""}
                    type={item?._type}
                    isOutOfScope={isOutOfScope}
                  >
                    {label}
                    {isOutOfScope && <ExternalIcon />}
                  </SiteLink>
                );
              })}
            </div>
          </div>
        </MaxWidth>
      </div>
    </footer>
  );
};
